<script setup>
defineProps({
  activePropertyType: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="cancellation-and-property-type-container">
    <CommonHwPropertyTypeNav
      class="property-type-navigation"
      :active="activePropertyType"
    />
  </div>
</template>

<style lang="scss" scoped>
.cancellation-and-property-type-container {
  width: 100%;
  border-top: 2px solid $wds-color-ink-lighter;
  border-bottom: 2px solid $wds-color-ink-lighter;
  display: flex;

  @include tablet {
    .property-type-navigation {
      padding: 0 $wds-spacing-s;
    }
  }

  @include desktop {
    flex-direction: row;
    justify-content: center;

    .property-type-navigation {
      padding: 0;
    }
  }
}
</style>
